import React from "react";
import Header from "../../../components/Header";
import AccountSettings from "../../../components/AccountSettings";
import Banner from "../../../components/Banner";
import { Link } from "react-router-dom";
import Topbar from "../../../components/Topbar";
import Bottombar from "../../../components/Bottombar";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import { PAYMENTS } from "../../../constants/settingsStrings.js";

function PaymentMethod() {
  return (
    <div className="overflow-hidden dark:bg-black bg-white dark:text-black h-screen">
      <Topbar />
      <Link to="/settings/payment">
        <ArrowLeftIcon
          color="#545454"
          className="ml-9 w-[20px] h-[30px] sm:hidden mt-2"
        />
      </Link>

      <div className="md:block hidden">
        <Header />
      </div>

      <div className="flex  justify-center items-center  mx-10">
        <div className="hidden md:block">
          <AccountSettings active={PAYMENTS} />
        </div>
        <div className="w-[925px]  sm:w-[64vw]  mt-2 h-[500px] rounded-[25px] sm:shadow-xl  sm:mx-10">
          <div className="ml-3 sm:ml-0">
            <Banner />
          </div>

          <p className="sm:hidden text-[17px] place-content-center grid mt-[34px] dark:text-white font-[600] py-7 ">
            Chusa+ is Uganda’s largest premium <br /> translating platform.
          </p>
          <div className="flex justify-between sm:mt-14 mt-5 space-y-6 sm:space-y-0  dark:text-white   items-center px-10">
            <div className="sm:space-y-3  space-y-5  text-[17px] sm:text-[10px] dark:text-white  font-[800]">
              <p>Month </p>
              <p>Amount</p>
              <p>Begins</p>
              <p>Ends</p>
              <p>Type</p>
            </div>

            <div className="sm:space-y-3 space-y-5 text-[15px] text-right">
              <p>March</p>
              <p>Amount-300ugx</p>
              <p>06 March, 2023</p>
              <p>06 April, 2023</p>
              <p>Standard</p>
            </div>
          </div>
          <div className="grid place-content-center   py-3  sm:mt-0">
            <div className=" flex  space-x-6 items-center  mt-7 sm:mt-0 ">
              <Link to="/settings/paymentselectionmethod">
                <button className="border text-[16px] rounded-[20px] w-[150px] h-[45px] border-[#030D30] hover:bg-[#BE2117] bg-[#BE2117]  text-white hover:text-white">
                  Subscribe
                </button>
              </Link>
              <Link to="/settings/payment">
                <button className="border rounded-[20px] w-[150px] h-[50px] text-white text-[16px] bg-[#BE2117]">
                  Cancel
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <h3 className="dark:text-black absolute text-[12px] md:block hidden  text-[#878787] font-[900] mt-9  sm:left-[50%]  bottom-[54px] left-[40%]">
        Terms and conditions{" "}
      </h3>
      <Bottombar activeBar={'settings'} />
    </div>
  );
}

export default PaymentMethod;
